import dayjs from 'dayjs';
import { LANG_DISPLAY_KEY } from '../constants/language';
import 'dayjs/locale/ja';
import * as Papa from 'papaparse';
import i18n from '../context/I18n';
import firebase, { db } from '../firebase/config';
import DB_TABLE from '../firebase/db-config';

export type ParsedCSVData = string[][];

export const convertText = (text: string) => {
  return text.split('_').join(' ').toLowerCase();
};

export const formatFirebaseTime = (second: number): string => {
  const lang = localStorage.getItem(LANG_DISPLAY_KEY) || 'ja';
  const date = second ? dayjs(second * 1000) : dayjs();

  if (lang === 'ja') {
    return date.locale('ja').format('YYYY年MM月DD日, HH:mm');
  } else {
    return date.format('DD/MM/YYYY, HH:mm');
  }
};

export const formatOrderId = (orderId: string = '') => {
  return orderId.slice(0, 6);
};

export const parseCSV = (file: string): Promise<ParsedCSVData> => {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      complete: (results) => {
        resolve(results.data as ParsedCSVData);
      },
      header: false,
      error: (error: any) => {
        reject(error);
      },
    });
  });
};

export const fetchMultipleSeatsByTableNumbers = async (stadiumId: string | null, tableNumbers: string[], preOrder?: boolean): Promise<Map<string, any>> => {
  const seatCache = new Map<string, any>();

  if (!stadiumId || tableNumbers.length === 0) {
    return seatCache;
  }

  try {
    const seat_doc = preOrder ? 'data_2026' : 'data';
    const seatsRef = db.collection(DB_TABLE.DB_TABLE_STADIUM_MANAGE_SEATS).doc(stadiumId).collection(seat_doc);

    const batchSize = 10;
    for (let i = 0; i < tableNumbers.length; i += batchSize) {
      const batch = tableNumbers.slice(i, i + batchSize);
      const querySnapshot = await seatsRef.where(firebase.firestore.FieldPath.documentId(), 'in', batch).get();

      querySnapshot.docs.forEach((doc) => {
        const data = doc.data();
        seatCache.set(doc.id, data);
      });
    }
  } catch (error) {
    console.error('Error pre-fetching seat data:', error);
  }

  return seatCache;
};

export const translate = (key: string, options?: any) => {
  return i18n.t(key, options);
};

export const omitFields = (obj: any, fields: string[]) => {
  if (!obj || typeof obj !== 'object') return obj;

  const clone = Array.isArray(obj) ? [...obj] : { ...obj };

  for (const field of fields) {
    delete clone[field];
  }

  return clone;
};

export const normalizeObject = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map(normalizeObject);
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj)
      .map((k) => k.trim())
      .sort()
      .reduce((acc, key) => {
        acc[key] = normalizeObject(obj[key]);
        return acc;
      }, {} as any);
  }
  return obj;
};
